import React from 'react';
import { autoPayPageLabels } from '../../constants/accountPanelConfigs';
import { AutoPayTypes } from '../../AutoPayTypes';
import { ExistingCardTypeIcon } from '../PayRent/CardTypeIcon';

export const PaymentDetailsCard = ({
  masked_card_number,
  cardType,
  expiration_date,
  billing_info,
}: AutoPayTypes.TPaymentDetailsCard) => {
  const {
    paymentInfo: { cardNumberLabel, expiryDateLabel },
  } = autoPayPageLabels;
  const {
    name: card_holder_name,
    address: { line1 = '', city = '', zip_code = '' } = {},
  } = billing_info ?? {};
  const displayMaskCardNumber = masked_card_number.replace(/-/g, ' - ');
  return (
    <div className="paymentInfoCard">
      <div className="subSection">
        <p className="subTitle has-text-weight-medium">{cardNumberLabel}</p>
        <div className="cardNumberSection">
          {displayMaskCardNumber}
          {cardType && <ExistingCardTypeIcon cardType={cardType} />}
        </div>
      </div>
      <div className="subSection">
        <p className="subTitle has-text-weight-medium">{expiryDateLabel}</p>
        <div className="expiryDate">
          {expiration_date?.month}/{expiration_date?.year}
        </div>
      </div>
      {card_holder_name && line1 && (
        <div className="subSection">
          <p className="pb-4">{card_holder_name}</p>
          <p>
            {' '}
            {line1} , {city} -{zip_code}
          </p>
        </div>
      )}
    </div>
  );
};
